<template>
  <div class='fill'>
    <br>
    <div class='fill'>
      <div class='fill'>
        <p>
          <b-icon icon='info-circle' font-scale='1.5' variant='info'></b-icon>
          Click "Explore" for sample's mCCC events, click "UMAP" to check cell types in the scRNA-seq sample.
        </p>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="panel panel-default" id="result-panel">
            <!-- Combined Row: Rows per page, Search Box, and Pagination -->
            <b-row class="d-flex align-items-center">
              <b-col sm="4">
                <b-form-group label-cols="4">
                  Rows per page:
                  <b-form-select v-model="rowsPerPage" :options="rowsOptions"></b-form-select>
                  of totally {{ filteredList.length }} datasets
                </b-form-group>
              </b-col>
              <b-col sm="4" class="px-0">
                <b-form-input 
                  v-model="searchQuery" 
                  placeholder="Search by dataset, tissue, or disease" 
                ></b-form-input>
              </b-col>
              <b-col sm="4" class="my-1 d-flex justify-content-end">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="filteredList.length"
                  :per-page="rowsPerPage"
                  aria-controls="dataset-table"
                ></b-pagination>
              </b-col>
            </b-row>

            <!-- Table -->
            <table class="table table-bordered table-hover" id="dataset-table">
              <thead>
                <tr>
                  <th v-for="(x, index) in Title" :key="index">
                    <span style="font-weight: bold">{{ x }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in paginatedList" :key="row.ID">
                  <td>{{ row.ID }}</td>
                  <td>{{ row.system }}</td>
                  <td>{{ row.tissue }}</td>
                  <td>{{ row.anatomic_site }}</td>
                  <td>{{ row.disease }}</td>
                  <td>{{ row.project }}</td>
                  <td>{{ row.celltype_num }}</td>
                  <td>{{ row.mebo_num }}</td>
                  <td>{{ row.source }}</td>
                  <!-- The UMAP needs more test -->
                  <td>
                    <b-button v-b-modal.modal-no-backdrop @click="showUmapPop(row.ID)">
                      View
                    </b-button>
                  </td>
                  <td>
                    <b-button @click="keyJump(row)">
                      <b-icon icon="view-stacked" aria-hidden="true"></b-icon>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>            

            <b-modal v-model='showUmap' size='xl' id="modal-no-backdrop" hide-backdrop content-class="shadow" ok-only title='UMAP Plot'>
              <b-overlay :show="isLoading" no-wrap></b-overlay>
              <p><span>Dataset: {{ umap_title }}</span></p>
              <img 
                width="100%"
                height="100%"
                center
                :src="umap_path"
              />
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BrowserVue',
  data () {
    return {
      isLoading: false,
      rowhover: false,
      curPage: 1,
      watchingId: '',
      Title: ['ID', 'System', 'Tissue', 'Anatomic_Site', 'Disease', 'Project', 'Celltype_Num', 'mCCC_Num', 'Source', 'UMAP', 'Explore'],
      list: [],
      umap_title: '',
      umap_path: '',
      umap_show_id: '',
      showUmap: false,
      rowsPerPage: 10, // Default rows per page
      currentPage: 1,  // Default page number
      rowsOptions: [10, 25, 50], // Dropdown options for rows per page
      searchQuery: '' // For search input
    }
  },
  created () {
    this.getData()
  },
  computed: {
    // Filter list based on searchQuery matching dataset, tissue, or disease
    filteredList() {
      const arrayList = Object.values(this.list);
      if (!this.searchQuery) {
        return arrayList;
      }
      const search = this.searchQuery.toLowerCase();
      return arrayList.filter(row => {
        return (
          (row.system && row.system.toLowerCase().includes(search)) ||
          (row.tissue && row.tissue.toLowerCase().includes(search)) ||
          (row.anatomic_site && row.anatomic_site.toLowerCase().includes(search)) ||
          (row.disease && row.disease.toLowerCase().includes(search)) ||
          (row.project && row.project.toLowerCase().includes(search)) ||
          (row.ID && row.ID.toLowerCase().includes(search))
        );
      });
    },
    // Paginate the filtered list
    paginatedList() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.filteredList.slice(start, end);
    },
  },
  methods: {
    keyJump (row) {
      if (this.$route.path === '/ccc'){
        this.$emit("callParent", row.ID+'__'+row.tissue+'__'+row.anatomic_site+'__'+row.disease);
      } else {
        sessionStorage.setItem('fromPush', 'true');
        this.$router.replace({
          path: '/ccc',
          query: {
            jump: true,
            browser_dataset: row.ID+'__'+row.tissue+'__'+row.anatomic_site+'__'+row.disease,
          }
        })
      }
    },
    showUmapPop (d) {
      this.umap_show_id = d;
      this.getData()
      this.umap_title = d;
      this.showUmap = true;
    },
    getData () {
      this.isLoading = true
      return axios.post('browser/', {
          task: 'browse',
          umap_show_id: this.umap_show_id,
      })
      .then(response => {
          var data = response.data;
          this.list = data.data;
          this.umap_path = `data:image/png;base64,${data.umap_url}`;
          this.isLoading = false
        })
        .catch(error => {
          console.warn(error);
          this.showToast('Notice!', 'Sorry for loading failed :(', 'warning');
          this.isLoading = false
        });
    },
    showToast (title, content, color) {
      this.$bvToast.toast(content, {
        title: title,
        variant: color,
        solid: true
      });
    }
  }
}
</script>

<style type="text/css">
.bg-custom {
  background-color: #3399FF !important;
}

.btn-custom {
  background-color: #3399FF !important;
  border-color: #3399FF !important;
  color: #fff !important;
}
</style>
